import axios from "axios";

const AUTHORIZE_URL =
  "https://gore-ecosphere-jaybird.ngrok-free.dev/node-3001/v1/aggregator/authorize";

const DECRYPT_URL =
  "https://gore-ecosphere-jaybird.ngrok-free.dev/node-3001/v1/aggregator/credentials/decrypt";

interface GreenEnergyAuthRequest {
  client_id: string;
  consumer_number: string;
  discom: string;
  organizationName: string;
  request_id: string;
  redirect_uri: string;
  credential_template: {
    ElectricityCredential: { version: string };
    // MeterDataCredential: { version: string; period: string };
  };
  purpose: string;
  validity: string;
  consent_version: string;
}

export async function authorizeGreenEnergy(
  discom: string,
  consumerNumber: string
) {
  const body: GreenEnergyAuthRequest = {
    client_id: "agg-oct-001",
    consumer_number: consumerNumber,
    discom: discom,
    organizationName: "OCT",
    request_id: crypto.randomUUID(),
    redirect_uri: "https://steering-happiest-handwrite.ngrok-free.dev/redirect.html",
    credential_template: {
      ElectricityCredential: { version: "1.2" }
    },
    purpose: "GREEN ENERGY OPT IN",
    validity: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    consent_version: "v2",
  };

  const response = await axios.post(AUTHORIZE_URL, body);
  return response.data;
}

export interface DecryptCredentialsRequest {
  request_id: string;
  status: string;
  credential?: string;
  meter_credential?: string;
  errorMsg?: string;
}

export async function decryptCredentials(payload: DecryptCredentialsRequest) {
  const response = await axios.post(DECRYPT_URL, payload);
  return response.data;
}

const VERIFY_BASE_URL =
  "https://gec-dev-backend.energymarketplace.in/gec-backend";

export async function verifyCertificate(certificateNo: string) {
  const response = await axios.get(`${VERIFY_BASE_URL}/api/v1/certificate/verify`, {
    params: { certificateNo: certificateNo.trim() },
  });
  return response.data;
}

// --- Registration APIs ---

export async function loginAdmin() {
  const response = await axios.post(`${VERIFY_BASE_URL}/api/v1/auth/login`, {
    email: "admin@pgvcl.com",
    password: "Password#123",
  });
  return response.data;
}

export interface RegisterConsumerRequest {
  user: {
    name: string;
    phone: string;
    email: string;
    role: string;
    companyId: string;
    password: string;
  };
  request: Array<{
    customer: {
      consumerNo: string;
      type: string;
      subCategory: string;
      substation: string;
      loadCategory: string;
      location: {
        state: string;
        city: string;
        pincode: string;
        address: string;
      };
      capacity: number;
      documents: any[];
    };
    meter: Array<{
      meterSerialNo: string;
      type: string;
      phase: string;
      installationDate: string;
      unit: string;
      frequency: string;
    }>;
    energyRequest: {
      energyUnits: number;
      pricePerUnit: number;
      thresholdValue: number;
      thresholdType: string;
      contractType: string;
      startDate: string;
      endDate: string;
      description: string;
      isVoluntary: boolean;
      rpoPercentage: number;
    };
  }>;
}

export async function registerConsumer(
  token: string,
  payload: RegisterConsumerRequest
) {
  const response = await axios.post(
    `${VERIFY_BASE_URL}/api/v2/admin/consumers/save`,
    payload,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
}
